const NOT_CONTAINS_TEST = new RegExp('^((?!test).)*$', 'i');

export default { NOT_CONTAINS_TEST };
